import type { ReactNode } from 'react';

export const symbol_hdr_weak: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M82.5-374.5Q39-418 39-481t43.5-106.5Q126-631 189-631t106.5 43.5Q339-544 339-481t-43.5 106.5Q252-331 189-331T82.5-374.5Zm429 63Q442-381 442-481t69.5-169.5Q581-720 681-720t169.5 69.5Q920-581 920-481t-69.5 169.5Q781-242 681-242t-169.5-69.5ZM808-354q52-52 52-127t-52-127q-52-52-127-52t-127 52q-52 52-52 127t52 127q52 52 127 52t127-52Z"
		/>
	</svg>
);
